
let config = {
    api : {
        'BASE_URL' : "http://localhost:8080"
    }
}

export default config